import { container } from 'tsyringe';
import { MediaService } from '@/core/media/services/MediaService';
import { copyTextToClipboard } from '@/ui/util/clipboard';

export const createShareLinkUseCase = async (
  customerId: string,
  campaignId: string,
  mediumId: string,
): Promise<void> => {
  const mediaService = container.resolve<MediaService>('MediaService');
  const response = await mediaService.createShareLink(customerId, campaignId, mediumId);
  const shareUrl = `${window.location.origin}/share/${response.secret}`;
  await copyTextToClipboard(shareUrl);
};
